import gql from 'graphql-tag'

const REFRESH_USER_TOKEN = gql` mutation($refreshToken: String!) {
    refreshTokenUser(input: {refreshToken: $refreshToken}) {
      user {
        token
      }
    }
  }`

const LOGIN = gql`mutation Login($email: String!, $password: String!) {
  loginUser(input: {email: $email, password: $password})  {
    user { token
      refreshToken
      email
      id
      userProfile {
        firstName
        lastName
        username
        image {
          contentUrl
        }
      }
      roles {
        id
      }
    }
  }
}`

const RESET_PASSWORD = gql`mutation ResetPassword($token: String!, $password: String!) {
  resetPasswordUser(input: {token: $token, password: $password } ) {
    user {
      email
      id
      token
      refreshToken
    }
  }
}
`
const REQUEST_RESET_PASSWORD = gql`mutation RequestResetPassword($email: String!) {
  requestResetPasswordUser(input: { email: $email } ) {
    user {
      id
    }
  }
}
`

const REGISTER_USER = gql`mutation RegisterUser($email: String!, $password: String!, $username: String!, $mediaObjectId: String) {
  registerUser(input: {email: $email, password: $password, username: $username, mediaObjectId: $mediaObjectId} ) {
    user {
      token
      refreshToken
      email
      id
      userProfile {
        id
        username
        image {
          contentUrl
        }
      }
    }
  }
}`

const USER = gql`query GetUser {
  getLoggedInUser {
    user {
      email
      id
      userProfile {
        id
        firstName
        lastName
        username
        image {
          id
          contentUrl
        }
      }
    }
  }
}`

export {
  REFRESH_USER_TOKEN,
  LOGIN,
  USER,
  RESET_PASSWORD,
  REQUEST_RESET_PASSWORD,
  REGISTER_USER,
}